import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { TitleModule } from '@smatchy/components/components/shared-ui/title/title.module';
import { AcceptedNewCgv, CgvSelectors, LoadCgvList, UserProfileSelector } from '@smatchy/core';
import { CgvVersionEntity } from '@smatchy/sdk';
import { filter, firstValueFrom } from 'rxjs';
import { IconModule } from '../../atoms/icon/icon.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '../../../../../core/services/language.service';

@Component({
  selector: 'smatchy-term-commission-policy',
  templateUrl: './term-commission-policy.component.html',
  styleUrls: ['./term-commission-policy.component.scss'],
  imports: [IonicModule, TranslateModule, TitleModule, IconModule, CommonModule, FormsModule],
})
export class TermCommissionPolicyModalComponent implements OnInit {
  accepted = false;
  /** Not known until the profile arrives. */
  commissionRate: number | null = null;
  userId: string | null = null;
  loading = false;
  policyHtml!: SafeHtml;
  constructor(
    private sanitizer: DomSanitizer,
    private readonly _store: Store,
    private readonly _modalCtrl: ModalController,
    private readonly _languageService: LanguageService,
  ) {}
  async ngOnInit() {
    const profile = await firstValueFrom(this._store.select(UserProfileSelector.profile));
    if (profile?.commissionPercent) {
      this.commissionRate = profile.commissionPercent;
    }
    // Not accepted is what an absent flag means, and what the field starts at.
    this.accepted = profile?.acceptedCommission ?? false;
    if (profile?.userId) {
      this.userId = profile.userId;
    }
    this._store.dispatch(
      new LoadCgvList({
        page: 1,
        limit: 1,
        type: 'commission',
        sortBy: 'updatedAt',
        sortOrder: 'desc',
      }),
    );

    this._store
      .select(CgvSelectors.lastVersion)
      .pipe(filter((rs) => !!rs))
      .subscribe((rs: CgvVersionEntity) => {
        const currentLang = this._languageService.getCurrentLang();
        const content =
          currentLang === 'en'
            ? rs.contentEn || rs.content || rs.contentFr
            : rs.contentFr || rs.content || rs.contentEn;
        // `?? ''`: all three language fields are optional on a version, so a
        // version carrying no text at all shows an empty policy rather than
        // the word undefined.
        this.policyHtml = this.sanitizer.bypassSecurityTrustHtml(content ?? '');
      });
  }
  close() {
    this._modalCtrl.dismiss();
  }
  async onSubmit() {
    try {
      this.loading = true;
      if (this.userId) {
        await this._store.dispatch(new AcceptedNewCgv(this.userId));
      }
      this.close();
    } catch (error) {
      console.log('accepted new cgv failed ', error);
    } finally {
      this.loading = false;
    }
  }
  changAccepted(value: boolean) {
    this.accepted = value;
  }
}
